<template>
  <section class="order-fulfillment">
    <header class="order-fulfillment-header">
      <h2>{{ $t('orderFulfillment.header.heading', { number: ff.transaction_id }) }}</h2>
      <div class="font-normal">
        <span class="mr-2" v-if="ff.shipping_carrier">{{ ff.shipping_carrier }}</span>
        <span v-if="ff.shipping_tracking">
          {{ $t('orderFulfillment.header.tracking', { number: ff.shipping_tracking }) }}
        </span>
      </div>
    </header>

    <div class="order-fulfillment-status">
      <h4 class="order-2 text-sm font-bold">
        {{ estimatesTimeDelivery }}
      </h4>
      <div class="order-1 mb-6">
        <ul class="order-fulfillment-status-tabs">
          <li
            v-for="(status, index) in tabOrders"
            :key="`tab-oders-${index}`"
            class="order-fulfillment-status-tabs-tab"
            :class="[tabStatus(status)]"
          >
            <div class="order-fulfillment-status-tabs-tab-content">
              <span class="inline-block mr-1">{{ capitalizeStatus(status) }}</span>
              <VSvgIcon
                v-if="isChecked(status)"
                name="check-circle"
                class="w-3 h-3 sm:h-5 sm:w-5"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="order-fulfillment-items">
      <div class="order-fulfillment-items-divider">
        <div class="order-fulfillment-items-divider-content" @click="toggleShowItems">
          <span>{{ $t('orderFulfillment.dropdown.btn') }}</span>
          <VSvgIcon
            name="chevron-up"
            class="order-fulfillment-items-divider-content-icon"
            :class="[showItems && 'flipped']"
          />
        </div>
      </div>
      <table v-if="showItems" class="order-fulfillment-items-table">
        <tr class="order-fulfillment-items-table-headings">
          <th>{{ $t('orderFulfillment.dropdown.table.ths.th1') }}</th>
          <th>{{ $t('orderFulfillment.dropdown.table.ths.th2') }}</th>
          <th>{{ $t('orderFulfillment.dropdown.table.ths.th3') }}</th>
        </tr>
        <tr class="order-fulfillment-items-table-data" v-for="item in ff.items.data" :key="item.id">
          <td>{{ item.item_name }}</td>
          <td class="large-column">
            {{ item.description }}
            <span v-if="item.serial_number">{{ item.serial_number }}</span>
          </td>
          <td class="text-right">{{ item.qty }}</td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import { format } from 'date-fns';
import VSvgIcon from '@/components/base/VSvgIcon';

import { capitalize } from '@/utils';

const TAB_ORDER = ['ordered', 'picked', 'packed', 'shipped'];

export default {
  name: 'OrderItem',
  components: { VSvgIcon },
  props: {
    ff: Object,
  },
  data() {
    return {
      showItems: true,
    };
  },
  computed: {
    tabOrders() {
      return TAB_ORDER.map(to => this.$t(`orderFulfillment.tabOrders.${to}`));
    },
    currentStatus() {
      return this.ff && !!this.ff.current_status ? this.ff.current_status.toLowerCase() : 'ordered';
    },
    estimatesTimeDelivery() {
      const status = this.ff && this.ff.is_shipped ? 'shipped' : 'noShipped';
      const quantity =
        this.ff && this.ff.items.data && this.ff.items.data.length === 1 ? 'single' : 'multiple';
      const shippingDate = this.ff && this.ff.shipping_date;
      const date = shippingDate ? format(new Date(shippingDate), 'M/d/yy') : '';
      const content = {
        single: {
          constant: this.$t('orderFulfillment.estimatesTimeDelivery.single.constant'),
          shipped: this.$t('orderFulfillment.estimatesTimeDelivery.single.shipped'),
          noShipped: this.$t('orderFulfillment.estimatesTimeDelivery.single.noShipped'),
        },
        multiple: {
          constant: this.$t('orderFulfillment.estimatesTimeDelivery.multiple.constant'),
          shipped: this.$t('orderFulfillment.estimatesTimeDelivery.multiple.shipped'),
          noShipped: this.$t('orderFulfillment.estimatesTimeDelivery.multiple.noShipped'),
        },
      };
      return `${content[quantity]['constant']} ${content[quantity][status]} ${date}`;
    },
  },
  methods: {
    capitalizeStatus(status) {
      return capitalize(status);
    },
    isCurrentTab(status) {
      return this.currentStatus === status;
    },
    isNextTab(status) {
      return TAB_ORDER.indexOf(status) > TAB_ORDER.indexOf(this.currentStatus);
    },
    isChecked(status) {
      return this.isCurrentTab(status) || !this.isNextTab(status);
    },
    tabStatus(status) {
      return this.isCurrentTab(status)
        ? 'current-tab'
        : this.isNextTab(status)
        ? 'next-tab'
        : 'past-tab';
    },
    toggleShowItems() {
      this.showItems = !this.showItems;
    },
  },
};
</script>
